module.exports = __webpack_public_path__ + "static/media/khebrat_footer_logo.a020935d.svg";